import { render, staticRenderFns } from "./SummarySidebar.vue?vue&type=template&id=0599a8b2&scoped=true&"
import script from "./SummarySidebar.vue?vue&type=script&lang=js&"
export * from "./SummarySidebar.vue?vue&type=script&lang=js&"
import style0 from "./SummarySidebar.vue?vue&type=style&index=0&id=0599a8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0599a8b2",
  null
  
)

export default component.exports